module.exports = __webpack_public_path__ + "img/align-left-02.ddf00902.svg";